import { Linking } from 'react-native';
export const openLinkingUrl = (url) => {
    if (Linking) {
        Linking.canOpenURL(url).then(() => Linking.openURL(url));
    }
};
